var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { ConfigurationService } from '../../configuration.service';
import { BackendService } from '../../backend.service';
var ProductItemDetailComponent = /** @class */ (function () {
    function ProductItemDetailComponent(configService, backendService) {
        this.configService = configService;
        this.backendService = backendService;
        this.showBody = false;
    }
    ProductItemDetailComponent.prototype.ngOnInit = function () {
        // Debug
        // this.currentItem = this.product.items[0];
    };
    ProductItemDetailComponent.prototype.eventIsAccepted = function (event) {
        if (event.dataTransfer) {
            if (event.dataTransfer.items.length === 0) {
                return false;
            }
            var types = [];
            for (var i = 0; i < event.dataTransfer.items.length; i++) {
                types.push(event.dataTransfer.items[i].type);
            }
            return types.every(function (type) { return type === 'image/png' || type === 'image/jpeg'; });
        }
        else {
            return false;
        }
    };
    ProductItemDetailComponent.prototype.drop_handler = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var filenames;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, this.backendService.uploadFiles(event.dataTransfer.files, this.configService.url, 'items')];
                    case 1:
                        filenames = _a.sent();
                        this.currentItem.imageUrl = filenames[0];
                        this.acceptFile = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductItemDetailComponent.prototype.dragover_handler = function (e) {
        this.acceptFile = this.eventIsAccepted(e);
        event.preventDefault();
    };
    ProductItemDetailComponent.prototype.dragleave_handler = function (e) {
        this.acceptFile = false;
    };
    Object.defineProperty(ProductItemDetailComponent.prototype, "showDetail", {
        get: function () {
            if (this.currentItem && this.currentLanguage) {
                if (this.currentItem.countries === undefined) {
                    this.currentItem.countries = {};
                }
                if (this.currentItem.countries[this.currentLanguage.code] === undefined) {
                    this.currentItem.countries[this.currentLanguage.code] = {};
                }
            }
            return this.currentItem !== undefined && this.currentLanguage !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    return ProductItemDetailComponent;
}());
export { ProductItemDetailComponent };
